import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { addItemToRent, getForRentSetsDetailsDataService } from './for-rent-sets-details-service';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    ButtonGroup,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Grid,
    TextField,
    Typography,
    makeStyles
} from '@material-ui/core';
import { Add, ArrowBack, Remove, ShoppingBasket } from '@material-ui/icons';
import { db } from '../../../../../firebase';
import logo from '../../../../../assets/logo.png'
import { showErrorSnackbar, showWarningSnackbar } from '../../../../shared/snackbar/snackbar-slice';

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    text: {
        color: "#111111",
    },
    title: {
        background:"#111111",
    },
}));

const initialFormData = {
    code: "",
    name: "",
    description: "",
    pieces: 0,
    original_price: 0,
    increase: 0,
    unit_price: 0,
    rent_price: 0,
    rent_percent: 0,
    deposit: 0,
    deposit_percent: 0,
    type: "",
    status: "",
    category: "",
    image_url: [],
    item_thumbnail: "",
};

const ForRentSetsDetails = () => {
    const classes = useStyles();
    const { set_id } = useParams();
    const [formData, setFormData ] = useState(initialFormData);
    const [selectedPhoto, setSelectedPhoto] = useState(logo);
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const rentalItems = useSelector((state) => state.requestRentSlice.rows);

    useEffect(() => {
        if (set_id) {
            const fetchData = async () => {
                try {
                    const result = await getForRentSetsDetailsDataService(dispatch, db, "items", set_id);
                    setFormData(result);
                    if (result.item_thumbnail) {
                        setSelectedPhoto(result.item_thumbnail);
                    }
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                    console.error("ForRentSetsDetails fetchData error: ", e);
                }
            };
            fetchData();
        }
    }, [set_id, dispatch]);

    const handleAddRent = async (itemData) => {
        try {
            const updatedFormData = [...rentalItems];

            // Check if itemData.id already exists in updatedFormData
            const existingItemIndex = rentalItems.findIndex((item) => item.code === itemData.code);
            
            if (existingItemIndex !== -1) {
                // If the item with the same id exists, update it
                dispatch(showWarningSnackbar(`${itemData.name} already added`));
            } else {
                // If the item with the same id doesn't exist, add it to the array
                updatedFormData.push(itemData);
                // Update the state with the new data
                await addItemToRent(dispatch, updatedFormData);
            }
        } catch(e) {
            dispatch(showErrorSnackbar('Add to rent failed! Please try again.'));
            console.error("ForRentWigsDetails handleAddRent error: ", e);
        }
    };

    const handleBack = () => {
        navigate('/app/for-rent/cosplay-sets');
    };

    const handleIncrease = () => {
        setValue((prevValue) => prevValue + 1);
    };
    
    const handleDecrease = () => {
        if (value > 0) {
            setValue((prevValue) => prevValue - 1);
        }
    };

    return (
       <>
            <Card
                variant="outlined"
                style={{
                    marginTop: '5vh',
                    padding: '5vh',
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                            <Button
                                variant="text"
                                className={classes.buttonText}
                                startIcon={<ArrowBack/>}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                        </div>
                        <CardMedia
                            component="img"
                            height="500px"
                            width="auto"
                            image={selectedPhoto}
                            alt="PeriCoCo"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h2" component="div" className={classes.text} align="left">
                                        {`${formData.name}`}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography sx={{ mb: 1.5 }} variant="h5" className={classes.text} align="left">
                                        {`Rent: PHP ${formData.rent_price}`}
                                    </Typography>
                                    <Typography sx={{ mb: 1.5 }} variant="h5" className={classes.text} align="left">
                                        {`Deposit: PHP ${formData.deposit}`}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                        {`Pieces: ${formData.pieces}`}
                                    </Typography>
                                    <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                        {formData.status}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                        {formData.description}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Grid>
                    <Grid item xs={6}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ display: 'flex' }}>
                                {
                                    formData.image_url && formData.image_url.length > 0 && (
                                        formData.image_url.map((row, index) => {
                                            return (
                                                <CardMedia
                                                    component="img"
                                                    style={{ height: '100px', width: '100px' }}
                                                    image={row}
                                                    alt="PeriCoCo"
                                                    onClick={() => setSelectedPhoto(row)}
                                                />
                                            )
                                        })
                                    )
                                }
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <CardActions style={{ justifyContent: "center" }}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <ButtonGroup>
                                        <Button
                                            variant="contained"
                                            className={classes.button}
                                            onClick={handleDecrease}
                                        >
                                            <Remove />
                                        </Button>
                                        <TextField
                                            disabled
                                            type="number"
                                            value={value}
                                            onChange={(e) => setValue(e.target.value)}
                                        />
                                        <Button
                                            variant="contained"
                                            className={classes.button}
                                            onClick={handleIncrease}
                                        >
                                            <Add />
                                        </Button>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    variant="contained"
                                    className={classes.button}
                                    startIcon={<ShoppingBasket/>}
                                    fullWidth
                                    disabled={!(formData.status === "Open for rent")}
                                    onClick={() => handleAddRent(formData)}
                                >
                                    Add to Rent
                                </Button>
                            </Grid>
                        </CardActions>
                    </Grid>
                </Grid>
            </Card>
       </>
    );
};

export default ForRentSetsDetails;